import Vue from "vue";

export class ScrollableList {
  constructor(loadFunction) {
    this.result = {
      list: [],
      currentPage: -1,
      totalSize: 0,
      lastScrollTop: 0
    };
    this.loadFromApi = loadFunction;
    this.fullyLoaded = false;
    this.loading = false;
    this.reverse = false;
    this.depth = 0;
  }

  removeDoublons(result) {
    let found = [];

    if (this.reverse === false) {
      for (let j = 0; j < result.length; j++) {
        let elt = result[j];
        for (let i = this.result.list.length - 1; i >= 0 && i >= this.result.list.length - 40; i--) {
          if (elt.profile.id === this.result.list[i].profile.id) found.push(j);
        }
      }
    }

    for (let ind in found) {
      result.splice(ind, 1);
    }
  }

  async load() {
    const thisObj = this;

    if (this.fullyLoaded) return Promise.resolve();

    this.loading = true;
    thisObj.result.currentPage++;

    try {
      const result = await this.loadFromApi(this);
      thisObj.loading = false;
      if (result && result.results.length !== 0) {
        this.removeDoublons(result.results);
        if (thisObj.reverse === true)
          thisObj.result.list = result.results
            .slice()
            .reverse()
            .concat(thisObj.result.list);
        else thisObj.result.list = thisObj.result.list.concat(result.results);
        thisObj.result.total = result.totalSize;
      } else thisObj.fullyLoaded = true;
      return result;
    } catch (error) {
      thisObj.fullyLoaded = true;
      thisObj.loading = false;
      return null;
    }
  }

  async loadUntilScrollCallback(done, container) {
    await this.load();
    await Vue.nextTick();
    this.depth++;
    if (
      this.depth == 2 ||
      container.clientHeight === 0 ||
      container.scrollHeight === 0 ||
      this.fullyLoaded === true ||
      3 * container.clientHeight < 2 * container.scrollHeight
    ) {
      if (done) {
        done();
      }
      return Promise.resolve();
    }
    return this.loadUntilScrollCallback(done, container);
  }

  async loadUntilScroll(container) {
    await Vue.nextTick();

    if (
      !(container.clientHeight === 0 && container.scrollHeight === 0) &&
      (this.fullyLoaded === true || 3 * container.clientHeight < 2 * container.scrollHeight)
    )
      return;
    return new Promise(resolve => {
      return this.loadUntilScrollCallback(resolve, container);
    });
  }

  async onScroll(container, store) {
    if (this.loading === false) {
      if (this.reverse === false && this.lastScrollTop < container.scrollTop) {
        if (container.scrollTop > (2 * (container.scrollHeight - container.clientHeight)) / 3) {
          if (store) store.commit("setLoading", true);
          await this.load();
          if (store) store.commit("setLoading", false);
        }
      }

      if (this.reverse === true && this.lastScrollTop > container.scrollTop) {
        if (container.scrollTop < (container.scrollHeight - container.clientHeight) / 3) {
          const oldHeight = container.scrollHeight;
          const oldTop = container.scrollTop;

          if (store) store.commit("setLoading", true);
          await this.load();
          await Vue.nextTick();
          if (store) store.commit("setLoading", false);
          container.scrollTop = container.scrollHeight - oldHeight + oldTop;
        }
      }
    }
    this.lastScrollTop = container.scrollTop;
  }

  findResult(idProfile) {
    const index = this.result.list.findIndex(el => el.profile.id === idProfile);
    return this.result.list[index];
  }

  pushToFirst(interlocutor) {
    if (this.result.list.length !== 0 && this.result.list[0] !== interlocutor) {
      const index = this.result.list.findIndex(el => el.profile.id === interlocutor.profile.id);
      this.result.list.splice(index, 1);
      this.result.list.splice(0, 0, interlocutor);
    }
  }

  removeResult(idProfile) {
    const index = this.result.list.findIndex(el => el.profile.id === idProfile);
    this.result.list.splice(index, 1);
    return index;
  }
}
